import { Card, CardContent } from "../ui/card";

/**
 * Stable-size placeholder rendered by every bento widget while its own
 * fetch is in flight. Eliminates the "pop-in cascade" flicker by keeping
 * each grid slot the same size during loading. When the widget's fetch
 * resolves and there is no content to show, the widget returns `null`
 * and the slot collapses cleanly (single layout shift instead of N).
 */
export default function BentoSlotSkeleton({ height = 96 }) {
  return (
    <Card
      data-testid="bento-slot-skeleton"
      className="border-border/60 bg-card/40 overflow-hidden"
    >
      <CardContent className="p-4">
        <div
          className="rounded-md bg-muted/40 animate-pulse"
          style={{ height: `${height}px` }}
          aria-hidden="true"
        />
      </CardContent>
    </Card>
  );
}
